import React from 'react';
import { NistFunctionPage } from '../../../components/assessment/nist/NistFunctionPage';
import { NIST_FUNCTIONS } from '../../../utils/nistAiRmf';
export function ManageFunction() {
  const functionData = NIST_FUNCTIONS.find(f => f.id === 'Manage')!;
  return <NistFunctionPage functionId="Manage" title={functionData.title} description={functionData.description} nextPath="/assessment/nist/analysis" prevPath="/assessment/nist/measure" data-id="element-474" />;
}